import type { Polygon } from "../types";

/**
 * Normalizes a license's offline area to the app's `[lat, lng]` polygon.
 *
 * The legacy portal delivers `[lat, lng]` pairs, while the new Datenportal
 * stores a GeoJSON Polygon (`{ type: "Polygon", coordinates: [[[lng, lat], …]] }`,
 * outer ring first). Licenses persisted before this normalization existed may
 * still hold the raw GeoJSON object, so this is applied when reading as well.
 */
export function normalizeOfflineArea(area: unknown): Polygon | undefined {
  if (Array.isArray(area)) return area.length ? (area as Polygon) : undefined;

  if (
    area &&
    typeof area === "object" &&
    (area as any).type === "Polygon" &&
    Array.isArray((area as any).coordinates?.[0])
  ) {
    const ring: unknown[] = (area as any).coordinates[0];
    const polygon = ring
      .filter(
        (p): p is [number, number] =>
          Array.isArray(p) &&
          typeof p[0] === "number" &&
          typeof p[1] === "number",
      )
      .map(([lng, lat]) => [lat, lng] as const);
    return polygon.length ? polygon : undefined;
  }

  return undefined;
}
